import { SFCheckIcon, ACTION_BAR_ACTION_NAMES, ACTION_BAR_ACTION_TYPES } from "@sf-core";


export const getActionDefs = (params) => {
  const {
    t,
    onCancelClick = () => {},
    onSaveClick  = () => {},
    onDeleteClick  = () => {},
    onRestoreClick  = () => {},
    formData,
  } = params;

  return [
    {
      name: ACTION_BAR_ACTION_NAMES.CANCEL,
      type: ACTION_BAR_ACTION_TYPES.BUTTON,
      onClick: onCancelClick,
      buttonProps: {
        label: t("components.toolbar.templates.cancel"),
        variant: "secondary",
      },
    },
    {
      name: ACTION_BAR_ACTION_NAMES.SAVE,
      type: ACTION_BAR_ACTION_TYPES.BUTTON,
      onClick: onSaveClick,
      buttonProps: {
        label: t("usersScreen.userProfileScreen.saveButton"),
        icon: <SFCheckIcon size="small" />,
        iconPlacement: "start",
        variant: "primary",
        async: true,

      },
      confirmation: true,
      confirmationProps: {
        header: t(
          "usersScreen.userTenantScreen.updateHeaderTenantConfirmMessage"
        ),
        message: t("usersScreen.userTenantScreen.updateTenantConfirmMessage"),
      },
    },
    {
      name: ACTION_BAR_ACTION_NAMES.DELETE,
      type: ACTION_BAR_ACTION_TYPES.BUTTON,
      onClick: onDeleteClick,
      disabled: !formData?.isActive,
      buttonProps: {
        label: t("usersScreen.userProfileScreen.deleteButton"),
        iconPlacement: "start",
        variant: "primary",
        async: true,

      },
      confirmation: true,
      confirmationProps: {
        header: t(
          "usersScreen.userTenantScreen.deleteHeaderTenantConfirmMessage"
        ),
        message: t("usersScreen.userTenantScreen.deleteTenantConfirmMessage"),
      },
    },
    ...(!formData?.isActive
      ? [ {
        name: "restore",
        type: ACTION_BAR_ACTION_TYPES.BUTTON,
        onClick: onRestoreClick,
        buttonProps: {
          label: t("usersScreen.userProfileScreen.restoreButton"),
          iconPlacement: "start",
          variant: "primary",
          async: true,
        },
        confirmation: true,
        confirmationProps: {
          header: t(
            "usersScreen.userTenantScreen.restoreHeaderTenantConfirmMessage"
          ),
          message: t("usersScreen.userTenantScreen.restoreTenantConfirmMessage"),
        },
      },]
      : [])
   
  ];
};



export default getActionDefs;